import React, { Component } from 'react';
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Form from 'react-bootstrap/Form';
import Button from 'react-bootstrap/Button'
import Card from 'react-bootstrap/Card'
import Alert from 'react-bootstrap/Alert'
import ModalYesNo from './ModalYesNo'
import ModalOK from './ModalOk'
import { MyContext, MyGlobal, MyHeading, MyAlert } from '../GlobalContext';
import { Thunderbolt } from 'react-bootstrap-icons';
import * as MySound from '../MySound';


export class PickItem extends Component {
    static displayName = PickItem.name;
    constructor(props) {
        super(props);
        this.state = {
            alertMessage: "",
            pickItem: props.location.state.pickItem, pickOptions: props.location.state.pickOptions, pickDirection: props.location.state.pickDirection, inputScanBarcode: "", togglePackTypes: false, scannedResult: "---", pickedQty: 0, resetPickedQty: false, enablePick: false, viewAttributes: false,
            showShortPickModal: false, showPartialMessage: false, reConfirmPartialPick: false, showGenericOkModal: false, genericOkModalMessage: "",
            selectedPickInfo: props.location.state.selectedPickInfo
        };
        this.history = props.history;

    }

    componentDidMount() {
        this.startPickTime();
        this.refs.barcodeScanInput.focus();
    }

    goto(page, data) {
        this.history.push({
            pathname: page,
            state: data
        });
    }

    render() {
        const handlebarcodeScanKeyPress = e => {
            if (e.keyCode === 13 || e.charCode === 13 || e.which === 13) {
                if (this.state.pickOptions.isGS1) {
                    this.validateBarcodeGS1();
                }
                else {
                    this.validateBarcode();
                }

            }
        };
        const handlepartialPickCheck = e => {
            var pickItemUpdated = this.state.pickItem;
            pickItemUpdated.isPartialPick = !pickItemUpdated.isPartialPick;
            this.setState({
                pickItem: pickItemUpdated, showPartialMessage: pickItemUpdated.isPartialPick
            })

        };

        return (
            <>{this.state.alertMessage.length > 0 && <Alert variant="danger">
                {this.state.alertMessage}
            </Alert>}
                {this.state.pickItem.warningMessage.length > 0 && <Alert variant="warning">
                    {this.state.pickItem.warningMessage}
                </Alert>}

                <Form>
                    <Row className="mb-3">
                        <Form.Group as={Col} controlId="formGridEmail">
                            <Form.Label>Pick Number</Form.Label>
                            <Form.Control placeholder="Enter pick number" readOnly={true} value={this.state.pickItem.pickNumber} />
                        </Form.Group>

                        <Form.Group as={Col} controlId="formGridPassword">
                            <Form.Label>Location</Form.Label>
                            <Form.Control readOnly={true} value={this.state.pickItem.locationBarcode} />
                        </Form.Group>
                    </Row>
                    <Form.Group className="mb-3" controlId="formGridAddress1">
                        <Form.Label>Product</Form.Label>
                        <Form.Text style={{ fontSize: "14px" }}>{this.state.pickItem.code}</Form.Text>
                        <Form.Text>{this.state.pickItem.description} </Form.Text>
                        <Form.Text>{this.state.pickItem.descriptioN2}</Form.Text>
                    </Form.Group>
                    {this.state.togglePackTypes && <Card className="mt-2 mb-2">
                        <Card.Header>
                            Pack Types
                        </Card.Header  >
                        <Card.Body>
                            <Container>
                                <Row>
                                    <Form.Group as={Col} className="col-2" >
                                        <Form.Text style={{ fontSize: "14px" }}>Size</Form.Text>
                                    </Form.Group>
                                    <Form.Group as={Col} className="col-3">
                                        <Form.Text style={{ fontSize: "14px" }}>Type</Form.Text>
                                    </Form.Group>
                                    <Form.Group as={Col}>
                                        <Form.Text style={{ fontSize: "14px" }}>Barcode</Form.Text>
                                    </Form.Group>
                                </Row>
                                {this.state.pickItem.packs.map(function (pack) {
                                    return (
                                        <Row key={pack.alt_pack_id}>
                                            <Form.Group as={Col} className="col-2">
                                                <Form.Text style={{ fontSize: "14px" }}>{pack.packsize}</Form.Text>
                                            </Form.Group>
                                            <Form.Group as={Col} className="col-3">
                                                <Form.Text style={{ fontSize: "14px" }}>{pack.description}</Form.Text>
                                            </Form.Group>
                                            <Form.Group as={Col}>
                                                <Form.Text style={{ fontSize: "14px" }}>{pack.bar_code}</Form.Text>
                                            </Form.Group>
                                        </Row>
                                    );
                                })}
                            </Container>
                        </Card.Body>
                    </Card>}
                    {this.state.viewAttributes && <Card className="mt-2 mb-2">
                        <Card.Header>
                            Attrributes
                        </Card.Header  >
                        <Card.Body>
                            <Row hidden={this.state.pickItem.dT_expiry === ""}>
                                <Form.Group as={Col}>
                                    <Form.Text style={{ fontSize: "14px" }}>EXP:</Form.Text>
                                </Form.Group>
                                <Form.Group as={Col}>
                                    <Form.Text style={{ fontSize: "14px" }}>{this.state.pickItem.dT_expiry}</Form.Text>
                                </Form.Group>
                            </Row>
                            <Row hidden={this.state.pickItem.dT_packing === ""}>
                                <Form.Group as={Col}>
                                    <Form.Text style={{ fontSize: "14px" }}>PACKED:</Form.Text>
                                </Form.Group>
                                <Form.Group as={Col}>
                                    <Form.Text style={{ fontSize: "14px" }}>{this.state.pickItem.dT_packing}</Form.Text>
                                </Form.Group>
                            </Row>
                            <Row hidden={this.state.pickItem.grade1Value === ""}>
                                <Form.Group as={Col}>
                                    <Form.Text style={{ fontSize: "14px" }}>{this.state.pickItem.grade1Name} : </Form.Text>
                                </Form.Group>
                                <Form.Group as={Col}>
                                    <Form.Text style={{ fontSize: "14px" }}>{this.state.pickItem.grade1Value}</Form.Text>
                                </Form.Group>
                            </Row>
                            <Row hidden={this.state.pickItem.grade2Value === ""}>
                                <Form.Group as={Col}>
                                    <Form.Text style={{ fontSize: "14px" }}>{this.state.pickItem.grade2Name} : </Form.Text>
                                </Form.Group>
                                <Form.Group as={Col}>
                                    <Form.Text style={{ fontSize: "14px" }}>{this.state.pickItem.grade2Value}</Form.Text>
                                </Form.Group>
                            </Row>
                            <Row hidden={this.state.pickItem.grade3Value === ""}>
                                <Form.Group as={Col}>
                                    <Form.Text style={{ fontSize: "14px" }}>{this.state.pickItem.grade3Name} : </Form.Text>
                                </Form.Group>
                                <Form.Group as={Col}>
                                    <Form.Text style={{ fontSize: "14px" }}>{this.state.pickItem.grade3Value}</Form.Text>
                                </Form.Group>
                            </Row>
                            <Row>
                                <Form.Group as={Col} className="mt-2" >
                                    <Button variant="success" onClick={() => { this.acknowledgeAttribute() }}>Acknowledge</Button>
                                </Form.Group>
                            </Row>
                        </Card.Body>
                    </Card>}
                    <Row >
                        <Form.Group as={Col}>
                            <Form.Control placeholder="Scan barcode"
                                value={this.state.inputScanBarcode}
                                ref="barcodeScanInput"
                                onChange={(e) => {
                                    this.setState({ inputScanBarcode: e.target.value });
                                }}
                                onKeyPress={handlebarcodeScanKeyPress}
                            />
                        </Form.Group>
                        <Button variant="primary" size="xs" className="mr-1" onClick={() => { this.setState({ inputScanBarcode: "" }) }}>
                            X
                        </Button>
                        <Button variant="primary" onClick={() => { this.setState({ togglePackTypes: this.state.togglePackTypes == true ? false : true }) }} >
                            Packs
                        </Button>
                    </Row>
                    <Row className="mt-2">
                        <Form.Group as={Col} className="col-2" >
                            <Form.Text style={{ fontSize: "14px" }}>Scanned</Form.Text>
                        </Form.Group>
                        <Form.Group as={Col}>
                            <Form.Text style={{ fontSize: "14px" }}>{this.state.scannedResult}</Form.Text>
                        </Form.Group>
                        <Form.Group as={Col}>
                            <Button variant="link" hidden={this.state.pickedQty > 0} onClick={() => { this.confirmPick() }}>Short All Items</Button>
                        </Form.Group>
                    </Row>
                    <Row className="mt-2">
                        <Form.Group as={Col} className="col-2" >
                            <Form.Text style={{ fontSize: "14px" }}>To Pick</Form.Text>
                        </Form.Group>
                        <Form.Group as={Col} className="col-3">
                            <Form.Text style={{ fontSize: "14px" }}>{this.state.pickItem.balance}</Form.Text>
                        </Form.Group>
                        <Form.Group as={Col} >
                            <Form.Text style={{ fontSize: "14px" }}>{this.state.pickItem.pickUOM}</Form.Text>
                        </Form.Group>
                    </Row>
                    <Row className="mt-2">
                        <Form.Group as={Col} className="col-2" >
                            <Form.Text style={{ fontSize: "14px" }}>Picked</Form.Text>
                        </Form.Group>
                        <Form.Group as={Col} className="col-3">
                            <Form.Control disabled={!this.state.pickItem.allowUserToEditQty}
                                value={this.state.pickedQty}
                                onChange={(e) => {
                                    this.setState({ pickedQty: e.target.value });
                                }} />
                        </Form.Group>
                        <Form.Group as={Col} className="col-2" >
                            <Form.Check type="checkbox" label="Partial" disabled={!this.state.enablePick}
                                onChange={handlepartialPickCheck}
                                defaultChecked={this.state.pickItem.isPartialPick}
                            />
                        </Form.Group>
                        <Form.Group as={Col} >
                            <Button variant="success" size="xs" hidden={!this.state.resetPickedQty} onClick={() => { this.setState({ pickedQty: 0, enablePick: false }) }} >Reset</Button>
                        </Form.Group>
                    </Row>
                    <Row className="mt-3">
                        <Form.Group as={Col}>
                            <Button variant="success" size="xs" onClick={() => this.cancelPick()} >Cancel</Button>
                        </Form.Group>
                        <Form.Group as={Col}>
                            <Button variant="success" size="xs" disabled={!this.state.pickItem.hasAttributes} onClick={() => { this.setState({ viewAttributes: true }) }}>Attributes</Button>
                        </Form.Group>
                        <Form.Group as={Col} >
                            <Button variant="success" size="xs" className="mt-1 float-right" disabled={!this.state.enablePick} onClick={() => { this.confirmPick() }}>Pick</Button>
                        </Form.Group>
                    </Row>
                </Form>
                <ModalYesNo title="Confirm" show={this.state.showShortPickModal} message="Please Confirm you want to short pick this location" onClickYes={(e) => { this.directToShortScreen() }} onClickNo={() => { this.setState({ showShortPickModal: false }); }}></ModalYesNo>
                <ModalOK title="Confirm" show={this.state.showPartialMessage} message="Only check this if someone will return here.  If this is a short pick please clear this, enter quantity picked and click Pick Item" onClickOk={() => { this.acknowledgePartialPick() }}  ></ModalOK>
                <ModalYesNo title="Confirm" show={this.state.pickItem.isPartialPick && this.state.reConfirmPartialPick} message="Confirm partial pick of this location" onClickNo={(e) => { this.setState({ reConfirmPartialPick: false }); }} onClickYes={() => { this.setState({ reConfirmPartialPick: false }); this.pickItem() }}></ModalYesNo>
                <ModalOK title="Confirm" show={this.state.showGenericOkModal} message={this.state.genericOkModalMessage} onClickOk={() => { this.setState({ showGenericOkModal: false, genericOkModalMessage: "" }) }}  ></ModalOK>

            </>
        );
    }

    validateBarcode() {
        var pickItemUpdated = this.state.pickItem;
        var scannedBarcode = this.state.inputScanBarcode;
        var barcodePack = null;
        var isBarcodeValid = false;
        this.state.pickItem.packs.forEach(function (value, index) {
            if (value.bar_code.trim().toUpperCase() === scannedBarcode.trim().toUpperCase()) {
                barcodePack = value;
            }
        });
        if (barcodePack !== null) {
            isBarcodeValid = true;
            this.setState({ scannedResult: barcodePack.description + " (" + barcodePack.packsize + ")" });
        }
        else {
            MySound.play(MySound.Sound.stop);
            pickItemUpdated.isBarcodeValid = isBarcodeValid;
            pickItemUpdated.allowUserToEditQty = false;
            this.setState({ scannedResult: "*Invalid Pack*", pickItem: pickItemUpdated, enablePick: false });
            this.refs.barcodeScanInput.select()
        }
        if (isBarcodeValid) {
            var pickedQty = parseInt(this.state.pickedQty) + parseInt(barcodePack.packsize);
            var quantityReset = this.state.pickOptions.barcodeScanRequirement === 3 ? true : false;
            pickItemUpdated.allowUserToEditQty = this.state.pickOptions.barcodeScanRequirement !== 3 ? true : false; // check if we can enable allow user to edit quantity
            pickItemUpdated.isBarcodeValid = isBarcodeValid;
            if (pickedQty > this.state.pickItem.balance) {
                MySound.play(MySound.Sound.stop);
                this.setState({ showGenericOkModal: true, genericOkModalMessage: "Over-picking is not permitted", enablePick: true });
            }
            else {
                this.setState({ pickedQty: pickedQty, inputScanBarcode: "", pickItem: pickItemUpdated, resetPickedQty: quantityReset, enablePick: true });
                MySound.play(MySound.Sound.next);

            }
        }
    }

    validateBarcodeGS1() {

        this.setState({ loading: true });
        var scannedBarcode = this.state.inputScanBarcode;
        const validateGS1Request = {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ scannedBarcode: scannedBarcode, nameCode: this.state.pickOptions.nameCode, pickData: this.state.pickItem })
        };
        fetch('api/PaperlessPicking/ValidateGS1Barcode', validateGS1Request) //
            .then(async response => {
                const isJson = response.headers.get('content-type')?.includes('application/json');
                const result = isJson ? await response.json() : null;
                // check for error response
                if (!response.ok) {
                    const errorText = "";
                    this.setState({ alertMessage: "", loading: false });
                    MySound.play(MySound.Sound.stop);
                }
                else {
                    if (result.success) {
                        MySound.play(MySound.Sound.next);
                        this.setState({ loading: false, alertMessage: "" });
                        var pickItemUpdated = this.state.pickItem;
                        pickItemUpdated.packs = result.data.packs;
                        this.setState({ pickItem: pickItemUpdated });
                        this.acknowledgeAttribute();
                        this.validateBarcode();
                    }
                    else {
                        if (result.errorMessage == "*Not a valid GS1 barcode*") {
                            this.validateBarcode(); 
                            this.setState({ loading: false, alertMessage: "" });
                        }
                        else {
                            this.setState({ loading: false, alertMessage: result.errorMessage });
                        }
                        
                    }
                }
            })
            .catch(error => {
                MySound.play(MySound.Sound.stop);
                this.setState({ loading: false, alertMessage: "OOOps an error occurred. Please try again!!!" });
            });
    }

    acknowledgeAttribute() {
        var pickItemUpdated = this.state.pickItem;
        pickItemUpdated.isAttributesAcknowledged = true;
        this.setState({ pickItem: pickItemUpdated, viewAttributes: false });
    }

    acknowledgePartialPick() {
        var pickItemUpdated = this.state.pickItem;
        pickItemUpdated.acknowledgePartialPick = true;
        this.setState({ pickItem: pickItemUpdated, showPartialMessage: false });
    }

    startPickTime() {
        var pickItemUpdated = this.state.pickItem;
        pickItemUpdated.pickStartTime = new Date();

    }

    isShortPick() {
        if (this.state.pickedQty < this.state.pickItem.balance && !this.state.pickItem.isPartialPick) {
            this.setState({ showShortPickModal: true });
            MySound.play(MySound.Sound.awhman);
            return true
        }
    }

    directToShortScreen() {
        this.setState({ showShortPickModal: false });
        var pickItem = this.state.pickItem;
        pickItem.pickedQty = this.state.pickedQty;
        this.goto('PickItemShorts', { pickItem: pickItem, pickOptions: this.state.pickOptions, pickDirection: this.state.pickDirection });
    }

    confirmPick() {
        if (this.isShortPick()) { return; }
        if (this.state.pickItem.isPartialPick && !this.state.reConfirmPartialPick) {
            this.setState({ reConfirmPartialPick: true });
            return;
        }
        this.pickItem();

    }

    async pickItem() {
        let userID = MyGlobal.user;
        var pickItemUpdated = this.state.pickItem;
        pickItemUpdated.pickedQty = this.state.pickedQty;
        this.setState({ loading: true });
        const pickRequest = {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ PickData: pickItemUpdated, PickOptions: this.state.pickOptions, userID: userID })
        };
        fetch('api/PaperlessPicking/PickItem', pickRequest) //
            .then(async response => {
                const isJson = response.headers.get('content-type')?.includes('application/json');
                const result = isJson ? await response.json() : null;
                // check for error response
                if (!response.ok) {
                    const errorText = response.statusText;
                    this.setState({ alertMessage: result.errorMessage, loading: false });
                }
                else {
                   if (result.success) {
                        MySound.play(MySound.Sound.next);
                        this.setState({ loading: false, alertMessage: "", });
                        var thisPick = this.state.pickItem;
                        this.goto('PickLocation', { pickNumber: thisPick.pickNumber, mheId: thisPick.pick_method_id, rowName: thisPick.row, pickDirection: this.state.pickDirection, pickOptions: this.state.pickOptions, selectedPickInfo :this.state.selectedPickInfo})
                    }
                    else {
                        this.setState({ loading: false, alertMessage: result.errorMessage });
                    }
                }
            })
            .catch(error => {
                this.setState({ loading: false, alertMessage: "OOOps an error occurred. Please try again!!!" });
            });
    }

    cancelPick() {
        let userID = MyGlobal.user;
        var pickItemUpdated = this.state.pickItem;
        pickItemUpdated.pickedQty = this.state.pickedQty;
        this.setState({ loading: true });
        const pickRequest = {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ PickData: pickItemUpdated, PickOptions: this.state.pickOptions, userID: userID })
        };
        fetch('api/PaperlessPicking/CancelPick', pickRequest) //
            .then(async response => {
                const isJson = response.headers.get('content-type')?.includes('application/json');
                const result = isJson ? await response.json() : null;
                // check for error response
                if (!response.ok) {
                    const errorText = response.statusText;
                    this.setState({ alertMessage: result.errorMessage, loading: false });
                }
                else {
                    if (result.success) {
                        this.setState({ loading: false, alertMessage: "", });
                        this.props.history.go(-1);
                    }
                    else {
                        this.setState({ loading: false, showGenericOkModal: true, genericOkModalMessage: result.errorMessage });
                        setTimeout(() => {
                            this.props.history.go(-1);
                        }, 3000);
                    }
                }
            })
            .catch(error => {
                this.setState({ loading: false, alertMessage: error });
            });
    }


}
export default PickItem;

